/*
  oms-carrinho — na ficha de produto, o botão diz que adicionou.

  O `product-form.js` do tema adiciona por AJAX, publica `cartUpdate` e entrega a
  resposta à gaveta do carrinho, que não abre: as secções que ela pede foram
  apagadas pela limpeza de 2026-09-09 (ver alteracoes/carrinho/LEIA-ME.md). Sem
  isto, o clique em «Adicionar ao carrinho» não dava sinal nenhum. Decisão do
  Júlio a 2026-09-25: a pessoa fica na ficha, e o botão diz que o snack ficou.

  Só ouve. Não mexe no `product-form.js`, no pedido nem na gaveta. O número do
  saco é do `oms-ohm.js`, que relê o /cart.js sozinho.

  O texto vem de `oms.carrinho.adicionado`, entregue pelo `layout/theme.liquid`
  em `window.omsCarrinho`, nas três línguas.
*/
/*
  A GAVETA (2026-09-26, revista a 2026-09-27). O saco do header, e qualquer link para o
  carrinho fora dela, abre a gaveta do tema em vez de ir para a página. Decisões do Júlio:
    · abre ao CLICAR, nunca ao passar o rato;
    · ABRE AO ADICIONAR (2026-09-27, revê a de 09-26), na ficha e na grelha da loja. Para
      não interromper quem junta muitos snacks (44% das encomendas só de snacks levam 5 ou
      mais diferentes), no computador abre AO LADO: não escurece a página, não prende a
      rolagem nem o foco, e a pessoa continua a adicionar com ela aberta. No telemóvel ocupa
      o ecrã todo, e por isso só abre sozinha na primeira adição da sessão; nas seguintes, o
      botão confirma e o saco conta;
    · na própria página do carrinho, o saco leva à página, que já é o carrinho.
  Clique do meio, Cmd ou Ctrl continuam a abrir a página noutro separador.

  O resto é do `cart-drawer.js` do tema: abrir, fechar, prender o foco, Escape, clique
  fora. A gaveta é desenhada no servidor ao carregar a página, portanto antes de abrir
  pede-se a secção `cart-drawer` (reposta a 2026-09-26, depois de a limpeza de 09-09 a ter
  apagado) e troca-se o conteúdo: a loja nova escreve no carrinho por `fetch` próprio, e
  sem isto a gaveta abria com o que havia quando a página carregou.
*/
(function () {
  'use strict';
  var gaveta = document.querySelector('cart-drawer');
  if (!gaveta || !window.routes || !window.customElements) return;
  var ROTA = window.routes.cart_url;
  var ESCRITA = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var mexeuNaGaveta = 0;

  customElements.whenDefined('cart-drawer').then(function () {
    var Gaveta = customElements.get('cart-drawer');

    // O product-form entrega a resposta da adição à gaveta. Em vez da abertura do tema, que
    // escurece a página e prende o foco, troca-se o conteúdo e abre-se pela regra de cima.
    Gaveta.prototype.renderContents = function (estado) {
      trocar(estado && estado.sections && estado.sections['cart-drawer']);
      aoAdicionar();
    };

    // A grelha da loja nova escreve no carrinho por `fetch` próprio e avisa quando um
    // snack novo foi aceite (`oms:carrinho:entrou`, no oms-loja-nova.js).
    document.addEventListener('oms:carrinho:entrou', function () {
      refrescar().then(aoAdicionar);
    });

    // A gaveta ao lado não prende o foco, portanto o Escape tem de se ouvir na página.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && gaveta.classList.contains('oms-ao-lado') && gaveta.classList.contains('active')) gaveta.close();
    });

    // Quem usa leitor de ecrã fica a saber que o saco abre um painel e não uma página.
    if (location.pathname !== ROTA) {
      document.querySelectorAll('a[href="' + ROTA + '"]').forEach(function (a) {
        if (!a.closest('cart-drawer')) a.setAttribute('aria-haspopup', 'dialog');
      });
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.closest('cart-drawer')) return;
      var destino = new URL(a.href, location.href);
      if (destino.origin !== location.origin || destino.pathname !== ROTA) return;
      if (location.pathname === ROTA) return;
      e.preventDefault();
      if (gaveta.classList.contains('active')) { gaveta.close(); return; }
      abrir(a);
    });

    // Ao fechar, a gaveta perde o modo ao lado depois de sair do ecrã, não antes.
    new MutationObserver(function () {
      if (gaveta.classList.contains('active') || !gaveta.classList.contains('oms-ao-lado')) return;
      setTimeout(function () {
        if (!gaveta.classList.contains('active')) gaveta.classList.remove('oms-ao-lado');
      }, 400);
    }).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
  });

  var LARGO = window.matchMedia('(min-width: 990px)');

  // A gaveta começa por baixo do header, que no topo das páginas com cabeça âmbar nasce
  // mais alto (66 px) e assenta depois de rolar (52 px): mede-se na hora.
  function acertarTopo() {
    var nav = document.querySelector('.ohm-nav');
    var fundo = nav ? Math.round(nav.getBoundingClientRect().bottom) : 0;
    gaveta.style.setProperty('--oms-gaveta-topo', Math.max(0, fundo) + 'px');
  }
  addEventListener('scroll', function () {
    if (gaveta.classList.contains('oms-ao-lado')) requestAnimationFrame(acertarTopo);
  }, { passive: true });

  // Aberta pelo saco, o foco entra nela e volta ao saco ao fechar. Aberta por uma adição,
  // o foco fica onde estava, para a pessoa continuar a escolher.
  function abrirAoLado(origem) {
    acertarTopo();
    gaveta.classList.add('oms-ao-lado');
    gaveta.activeElement = origem || null;
    setTimeout(function () {
      gaveta.classList.add('animate', 'active');
      if (origem) {
        var alvo = gaveta.querySelector('.drawer__close');
        if (alvo) alvo.focus({ preventScroll: true });
      }
    });
  }

  function aoAdicionar() {
    if (LARGO.matches) { abrirAoLado(null); return; }
    try {
      if (sessionStorage.getItem('oms-gaveta-vista')) return;
      sessionStorage.setItem('oms-gaveta-vista', '1');
    } catch (e) { /* sem sessionStorage (modo privado antigo): abre sempre */ }
    gaveta.open(document.activeElement);
  }

  function trocar(html) {
    if (!html) return false;
    var novo = new DOMParser().parseFromString(html, 'text/html');
    var dentro = novo.querySelector('#CartDrawer');
    var fora = novo.querySelector('cart-drawer');
    if (!dentro) return false;
    document.getElementById('CartDrawer').innerHTML = dentro.innerHTML;
    if (fora) gaveta.classList.toggle('is-empty', fora.classList.contains('is-empty'));
    var fundo = gaveta.querySelector('#CartDrawer-Overlay');
    if (fundo) fundo.addEventListener('click', gaveta.close.bind(gaveta));
    return true;
  }

  function refrescar() {
    return fetch(ROTA + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(trocar)
      .catch(function () { return false; });
  }

  // Abre com o que o servidor diz agora. Se a rede demorar, abre na mesma ao fim de
  // 700 ms com o que já lá está, e troca quando a resposta chegar.
  function abrir(origem) {
    var aberta = false;
    var abreJa = function () {
      if (aberta) return;
      aberta = true;
      if (LARGO.matches) abrirAoLado(origem); else gaveta.open(origem);
    };
    var prazo = setTimeout(abreJa, 700);
    refrescar().then(function () { clearTimeout(prazo); abreJa(); });
  }

  // Com a gaveta aberta, uma escrita que venha de fora dela (a fila da loja nova, que
  // junta toques seguidos) volta a pedi-la. As da própria gaveta já a redesenham.
  gaveta.addEventListener('pointerdown', function () { mexeuNaGaveta = Date.now(); });
  gaveta.addEventListener('keydown', function () { mexeuNaGaveta = Date.now(); });
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (lista) {
        if (!gaveta.classList.contains('active') || Date.now() - mexeuNaGaveta < 3000) return;
        if (lista.getEntries().some(function (e) { return ESCRITA.test(e.name); })) refrescar();
      }).observe({ type: 'resource' });
    } catch (e) { /* browsers sem o tipo `resource`: fica sem o refresco */ }
  }

  // O que muda na gaveta avisa a loja nova, que ouve `cart:refresh` para acertar as fichas.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'cart-items') document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }
})();

/*
  No carrinho, a segunda parte: a barra do telemóvel (total e botão de pagar presos ao
  fundo) só aparece enquanto o botão do resumo não está à vista. O CSS esconde-a quando o
  `<html>` tem `oms-pagar-visivel`. O botão observado (`#checkout`) não é redesenhado pelo
  cart.js, portanto observa-se uma vez e chega.
*/
(function () {
  'use strict';
  var pagar = document.getElementById('checkout');
  if (!pagar || !('IntersectionObserver' in window)) return;
  var raiz = document.documentElement;
  new IntersectionObserver(function (entradas) {
    raiz.classList.toggle('oms-pagar-visivel', entradas[0].isIntersecting);
  }).observe(pagar);
})();

(function () {
  'use strict';

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  var TEXTO = (window.omsCarrinho || {}).adicionado;
  if (!TEXTO) return;
  if (!document.querySelector('product-form')) return;

  var DURA = 2600;
  var ultimo = null;

  // O `cartUpdate` traz a variante mas não o formulário. O último formulário
  // submetido é o que foi clicado; a captura corre antes do handler do tema.
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('product-form') : null;
    if (f) ultimo = f;
  }, true);

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
    if (!ev || ev.source !== 'product-form' || !ultimo) return;
    confirmar(ultimo);
  });

  function confirmar(form) {
    var botao = form.querySelector('[type="submit"]');
    var rotulo = botao ? botao.querySelector('span') : null;
    if (!rotulo) return;

    if (botao.dataset.omsRotulo === undefined) botao.dataset.omsRotulo = rotulo.textContent;
    clearTimeout(botao.omsVolta);
    rotulo.textContent = TEXTO;
    botao.classList.add('oms-adicionado');
    anunciar(form);

    botao.omsVolta = setTimeout(function () {
      rotulo.textContent = botao.dataset.omsRotulo;
      delete botao.dataset.omsRotulo;
      botao.classList.remove('oms-adicionado');
    }, DURA);
  }

  // A troca de texto dentro de um botão não é lida por quem usa leitor de ecrã.
  function anunciar(form) {
    var r = form.querySelector('.oms-carrinho-aviso');
    if (!r) {
      r = document.createElement('span');
      r.className = 'oms-carrinho-aviso visually-hidden';
      r.setAttribute('role', 'status');
      form.appendChild(r);
    }
    r.textContent = '';
    setTimeout(function () { r.textContent = TEXTO; }, 60);
  }

  // O visto antes do texto. É máscara sobre `currentColor`, e não um glifo,
  // porque a Nantes não tem o U+2713 e cairia noutra letra.
  var css = document.createElement('style');
  css.textContent =
    '.oms-adicionado > span::before{content:"";display:inline-block;width:.95em;height:.95em;' +
    'margin-right:.5em;vertical-align:-.12em;background:currentColor;' +
    '-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\'%3E%3Cpath d=\'M4 12.5l5 5L20 6.5\' fill=\'none\' stroke=\'%23000\' stroke-width=\'2.6\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/contain no-repeat;' +
    'mask:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\'%3E%3Cpath d=\'M4 12.5l5 5L20 6.5\' fill=\'none\' stroke=\'%23000\' stroke-width=\'2.6\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/contain no-repeat}';
  document.head.appendChild(css);
})();
